import React from 'react';

export interface CalloutCardProps {
  title: string;
  children?: React.ReactNode;
  actionLabel?: string;
  actionHref?: string;
}

export const CalloutCard: React.FC<CalloutCardProps> = ({ title, children, actionLabel, actionHref }) => (
  <div className="callout-card">
    <h4>{title}</h4>
    {children}
    {actionLabel && (
      <a className="btn-teal" href={actionHref} style={{ marginTop: 12, display: 'inline-block' }}>
        {actionLabel}
      </a>
    )}
  </div>
);
